import Content from "./AccordionContent.svelte"
import Item from "./AccordionItem.svelte"
import Root from "./AccordionRoot.svelte"
import Trigger from "./AccordionTrigger.svelte"

export const Accordion = {
  Root,
  Content,
  Item,
  Trigger,
}
